import { BackendHttpService } from "../backendHttpService";

export class RolesDictionaryService extends BackendHttpService {
    private rolesCache: string[] | null = null;

    constructor() {
        super("Project");
    }

    async getRolesDictionary(): Promise<string[]> {
        if (this.rolesCache) {
            return this.rolesCache;
        }
        try {
            this.rolesCache = Array.from(new Set(
                (await this.get<string[]>("/rolesDictionary"))
                    .filter((r): r is string => !!r?.trim())
                    .map((r) => r.trim())
            ));
            return this.rolesCache;
        } catch (error) {
            console.error("Error getting roles dictionary:", error);
            throw error;
        }
    }

    clearCache(): void {
        this.rolesCache = null;
    }
}

export const rolesDictionaryService = new RolesDictionaryService();
